import { useQuery } from "@tanstack/react-query";

const LEGAL_BASE_URL = "https://legal.usesky.ai";

const LEGAL_QUERY_STALE_TIME = 24 * 60 * 60 * 1000; // 24 hours

type LegalDocumentType = "terms" | "privacy-policy";

const LEGAL_ENDPOINTS: Record<LegalDocumentType, string> = {
  terms: `${LEGAL_BASE_URL}/terms?format=html`,
  "privacy-policy": `${LEGAL_BASE_URL}/privacy-policy?format=html`,
};

async function fetchLegalDocument(type: LegalDocumentType): Promise<string> {
  const response = await fetch(LEGAL_ENDPOINTS[type]);
  if (!response.ok) {
    throw new Error(`Failed to load legal document: ${response.statusText}`);
  }
  return response.text();
}

export function useLegalDocument(type: LegalDocumentType) {
  return useQuery({
    queryKey: ["legal-document", type],
    queryFn: () => fetchLegalDocument(type),
    staleTime: LEGAL_QUERY_STALE_TIME,
    gcTime: LEGAL_QUERY_STALE_TIME,
  });
}
